"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const framer_motion_1 = require("framer-motion");
const helpers_1 = require("../../lib/helpers");
const withJourney_1 = __importDefault(require("../../hocs/withJourney"));
const animations_1 = require("../../lib/config/animations");
const BackDrop = (props) => {
    const primitiveProps = helpers_1.usePrimitiveProps(props);
    return (react_1.default.createElement(framer_motion_1.AnimatePresence, null, props.isOpen
        ? (react_1.default.createElement(framer_motion_1.motion.div, Object.assign({ exit: "closed", initial: "closed", animate: "open" }, primitiveProps, { variants: animations_1.FadeInAnim.variants, transition: animations_1.FadeInAnim.transition }))) : null));
};
exports.default = withJourney_1.default('j-back-drop', BackDrop);
